import PopWrapper from '../utils/PopWrapper';
import Banner from './Banner';

const PopBanner = PopWrapper(Banner);

export {Banner};
export {PopBanner};

